export default "__VITE_ASSET__6r9WK_RB__"